export default __webpack_public_path__ + "static/media/discord.2fd00b86.svg";